import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "spotsModal" ]

  connect() {
  }

  showSpotsModal(event) {
    $(this.spotsModalTarget).find(".modal-header .text-primary").empty()
    $(this.spotsModalTarget).find(".modal-body").empty()
    $.ajax({
      url: $(event.target).closest("a").data("url").concat(".js")
    })
    $(this.spotsModalTarget).modal('show')
  }
}
